.page {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: calc(var(--bottom-chrome) + 24px);
  animation: bb-fade-in var(--t-med) var(--ease);
}

.flush {
  padding-bottom: var(--bottom-chrome);
}

.header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: 56px 1fr 56px;
  align-items: center;
  min-height: 56px;
  padding: var(--safe-t) 4px 0;
  background: rgb(0 0 0 / 0.86);
  backdrop-filter: blur(18px);
}

.headerTransparent {
  background: transparent;
  backdrop-filter: none;
  position: absolute;
  left: 0;
  right: 0;
}

.headerSide {
  display: flex;
  align-items: center;
}

.headerActions {
  justify-content: flex-end;
}

.headerTitle {
  text-align: center;
  font-size: var(--fs-md);
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.section {
  margin-top: 28px;
}

.sectionHead {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 0 var(--gutter);
  margin-bottom: 12px;
}

.sectionHead h2 {
  font-size: var(--fs-lg);
  font-weight: 800;
  letter-spacing: -0.02em;
}

.sectionLink {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--text-3);
}

.sectionLink:hover {
  color: var(--text);
}

.shelf {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 0 var(--gutter) 4px;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
}

.shelf::-webkit-scrollbar {
  display: none;
}

.shelf > * {
  scroll-snap-align: start;
  flex-shrink: 0;
}
